import stripTags from 'striptags'
import { decode } from 'html-entities'
import { config } from '@/config'

export default {
  async fetchLatestPosts ({ dispatch }, limit = 3) {
    let latestPosts = []
    try {
      const xmlData = await dispatch('xml/fetch', {
        url: config.blogFeedUrl
      }, { root: true })

      latestPosts = xmlData.rss.channel.item
        .slice(0, limit)
        .map(e => ({
          title: e.title._text,
          description: decode(stripTags(e.description._cdata)),
          link: e.link._text,
          pubDate: new Date(e.pubDate._text)
        }))
    } catch (error) {}

    return latestPosts
  }
}
